import { Pipe, PipeTransform } from '@angular/core'
import { userRoleToString } from '@tokeet-frontend/tv3-platform'
import { USER_ROLES, User } from '@tokeet-frontend/tv3-platform'
import * as R from 'ramda'

@Pipe({
  name: 'staffPermissions',
})
export class StaffPermissionsPipe implements PipeTransform {
  constructor() {}

  transform(user: User, canSee: 'email' | 'name' | 'phone' | 'booking_comments') {
    if (userRoleToString(user?.roles || []) != USER_ROLES.staff.name) {
      return true
    }

    let settings: Record<string, unknown> = R.pathOr({}, ['staff_settings'], user?.attributes)

    if (canSee === 'booking_comments') {
      // default to "true" if not set
      return typeof settings[canSee] === 'boolean' ? settings[canSee] : true
    }

    settings = { ...settings, guest_name: true } // always show name

    return R.pathOr(false, [`guest_${canSee}`], settings)
  }
}
